import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PassengersDesktopScreen from './desktop/PassengersDesktopScreen';
import PassengersMobileScreen from './mobile/PassengersMobileScreen';
import FlightsScreenController from '../flights/FlightsScreenController';
import RoutesSwitchController from '../../components/flights/routesSwitch/RoutesSwitchController';
import ProgressBarCenter from '../../components/ProgressBarCenter';
import ScreenDetection from '../../components/ScreenDetection';
import Constants from '../../model/AppConfiguration';

/**
 * ## Redux imports
 */
import * as routesActions from '../../redux/actions/RoutesActions';
import * as flightsActions from '../../redux/actions/FlightsActions';
import * as passengerActions from '../../redux/actions/PassengerActions';
import * as passengersActions from '../../redux/actions/PassengersActions';
import * as allFlightsActions from '../../redux/actions/AllFlightsActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';
import Navigation from '../../components/navigation/Navigation';

/**
 * ## Redux boilerplate
 */
const actions = [
  routesActions,
  flightsActions,
  allFlightsActions,
  passengerActions,
  passengersActions,
];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    general: selectors.general.getAll(state.general),
    reservationId: selectors.general.getReservationId(state.general),
    routes: selectors.routes.getRoutes(state.routes),
    flights: selectors.flights.getFlights(state.flights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class PassengersScreen extends Component {
  static propTypes = {
    actions: PropTypes.object,
    isFetching: PropTypes.bool,
    flights: PropTypes.arrayOf(PropTypes.object),
    routes: PropTypes.arrayOf(PropTypes.object),
  };

  constructor (props) {
    super(props);

    this.findRouteById = FlightsScreenController.findRouteById.bind(this);
    this.findTripByRoute = FlightsScreenController.findTripByRoute.bind(this);
    this.toggleRoutes = RoutesSwitchController.toggleRoutes.bind(this);
    let trips = [ { id: '1', label: 'One Way' }, { id: '2', label: 'RoundTrip' } ];
    this.state = {
      selectedRoute: null,
      selectedTrip: trips[ 0 ],
      trips: trips,
    };

    if (props.reservationId) {
      props.actions.getFlights(Constants.REQUEST.PASSENGERS, props.reservationId);
    }
  }

  componentDidMount () {
    const { flights, reservationId, isFetching, actions } = this.props;
    if (!isFetching && !flights && reservationId) {
      actions.getFlights(Constants.REQUEST.PASSENGERS, reservationId);
    }
  }

  componentWillReceiveProps (props) {
    const { flights, routes, isFetching } = props;

    let routeId = flights && flights.length ? flights[ 0 ].routeId : null;

    if (!isFetching && !this.state.selectedRoute && routes && routes.length) {
      this.setState({
        selectedRoute: this.findRouteById(routeId, routes),
        selectedTrip: this.findTripByRoute(flights),
      });
    }
    if (!isFetching && !routes) {
      this.props.actions.getRoutes();
    }
  }

  submitData = step => {
    this.props.actions.submitFlights(
      Constants.REQUEST.PASSENGERS,
      this.props.general,
      this.props.flights,
      step
    );
  };

  render () {
    const { selectedRoute, selectedTrip } = this.state;
    const { routes, general, actions } = this.props;
    if (!selectedRoute && !routes) {
      return <ProgressBarCenter />;
    }

    return (
      <Navigation
        submitData={this.submitData}
        screen={
          <ScreenDetection
            mobileScreen={
              <PassengersMobileScreen
                showDate
                routes={routes}
                selectedTrip={selectedTrip}
                selectedRoute={selectedRoute}
                toggleRoutes={this.toggleRoutes}
                general={general}
                getPassengerDetails={actions.getPassengerDetails}
                routeId={selectedRoute ? selectedRoute.id : ''}
              />
            }
            desktopScreen={
              <PassengersDesktopScreen
                showDate
                routes={routes}
                selectedTrip={selectedTrip}
                selectedRoute={selectedRoute}
                toggleRoutes={this.toggleRoutes}
                general={general}
                getPassengerDetails={actions.getPassengerDetails}
                routeId={selectedRoute ? selectedRoute.id : ''}
              />
            }
          />
        }
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PassengersScreen);



// WEBPACK FOOTER //
// ./src/containers/passengers/PassengersScreen.js